import(/* webpackMode: "eager" */ "/var/www/academy-frontend/src/app/(home)/layout.js");
